import { AppThunk } from '../../../store/rootReducer';
import {
  userSelector,
  preferencesSelector,
} from '../../auth/selectors/auth.selectors';
import * as ecgActions from '../../ecg/actions/ecg.actions';
import * as diagnosticActions from '../actions/diagnostic.actions';
import { Diagnostic } from '../types/diagnostic';
import { filterDiagnostics, isDiagnosticEmpty } from '../utils/diagnostic.util';
import { getUserDiagnostic } from '../utils/get-user-diagnostic.util';

export const loadDiagnostics =
  (diagnostics: Diagnostic[]): AppThunk =>
  async (dispatch, getState) => {
    const user = userSelector(getState());
    const preferences = preferencesSelector(getState());
    if (user == null || preferences == null) {
      return;
    }

    const filteredDiagnostics = filterDiagnostics(diagnostics, getState);
    const userDiagnostic = getUserDiagnostic(
      filteredDiagnostics,
      user,
      preferences,
    );

    // TODO: need to check that why even if a user diagnostic exists when we load the app the save diagnostic button is active
    let editableDiagnostic = userDiagnostic;
    // when there is no user diagnostic first we need to differentiate the editable from base
    // diagnostic in order to be able to save an empty diagnostic this is why in this case
    // we set the editable with the same object but with a different reference
    if (isDiagnosticEmpty(userDiagnostic)) {
      editableDiagnostic = { ...userDiagnostic };
    }

    dispatch(
      diagnosticActions.setDiagnostics({
        editableDiagnostic,
        baseDiagnostic: userDiagnostic,
        diagnostics: filteredDiagnostics,
        meta: { history: false },
      }),
    );

    dispatch(
      ecgActions.update({
        update: { pipeline: userDiagnostic.pipeline },
        meta: { history: false },
      }),
    );
  };
